// src/hooks/useAuth.ts
import {useSelector} from "react-redux";
import {
  selectCurrentUser,
  selectIsAuthenticated,
  selectAuthLoading,
} from "../store/slices/authSlice";
import {UserRole} from "../types";

export const useAuth = () => {
  const user = useSelector(selectCurrentUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isLoading = useSelector(selectAuthLoading);

  const isAdmin = () => user?.role === UserRole.ADMIN;
  const isUser = () => user?.role === UserRole.CUSTOMER;

  return {
    user,
    isAuthenticated,
    isLoading,
    isAdmin,
    isUser,
  };
};
